"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.FormContainer = void 0;
var design_language_1 = require("@doordash/design-language");
var styled_components_1 = __importDefault(require("styled-components"));
exports.FormContainer = styled_components_1["default"](design_language_1.InlineChildren).attrs({
    justifyContent: design_language_1.InlineChildren.Justification.SpaceBetween,
    alignItems: design_language_1.InlineChildren.Alignment.FlexStart
})(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
